import React, { useState, useEffect } from 'react';
import { Form, Button, Alert } from 'react-bootstrap';
import { useNavigate, useLocation } from 'react-router-dom';
import { getAuth, confirmPasswordReset, sendPasswordResetEmail } from 'firebase/auth';

const auth = getAuth();

const AuthForm = ({
  isSignUp,
  email,
  setEmail,
  password,
  setPassword,
  handleAuth,
  toggleAuthMode,
  resetMode,
  setResetMode,
  resetEmail,
  setResetEmail,
  error,
  setError,            // ✅ This prop is now explicitly included
  successMessage
}) => {
  const navigate = useNavigate();
  const location = useLocation();
  const [validationError, setValidationError] = useState("");
  const [newPassword, setNewPassword] = useState("");
  const [resetSuccess, setResetSuccess] = useState(false);
  const [oobCode, setOobCode] = useState(null);
  const [resetEmailSent, setResetEmailSent] = useState(false);
  const [resetEmailError, setResetEmailError] = useState("");

  useEffect(() => {
    const params = new URLSearchParams(location.search);
    const mode = params.get("mode");
    const code = params.get("oobCode");
    const loginRequired = params.get("error");
  
    if (mode === "resetPassword" && code) {
      setOobCode(code);
      setResetMode(true);
    }
  
    if (loginRequired === "login-required") {
      setError("Please log in to continue");
    }
  }, [location.search, setResetMode, setError]);
  



  const validateEmail = (email) => /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);
  const validatePassword = (password) => password.length >= 8;

  // const handleAuthWithValidation = async (e) => {
  //   e.preventDefault();
  //   setValidationError("");

  //   if (!validateEmail(email)) {
  //     setValidationError("❌ Please enter a valid email address.");
  //     return;
  //   }

  //   if (!validatePassword(password)) {
  //     setValidationError("❌ Password must be at least 8 characters long.");
  //     return;
  //   }

  //   await handleAuth(e);
  // };

  const handleAuthWithValidation = async (e) => {
    e.preventDefault();
    setValidationError("");
    setError("");
  
    if (!validateEmail(email)) {
      setValidationError("❌ Please enter a valid email address.");
      return;
    }
  
    if (!validatePassword(password)) {
      setValidationError("❌ Password must be at least 8 characters long.");
      return;
    }
  
    try {
      await handleAuth(e);
    } catch (err) {
      console.error("Auth Error:", err.code);
      const errorMapping = {
        "auth/user-not-found": "❌ We can't recognize you. Try again.",
        "auth/wrong-password": "❌ We can't recognize you. Try again.",  // "auth/wrong-password": "❌ Incorrect password. Try again.",
        "auth/invalid-email": "❌ We can't recognize you. Try again.",  //  ❌ Please enter a valid email address.
        "auth/too-many-requests": "❌ Too many failed attempts. Please try again later.",
        "auth/email-already-in-use": "❌ This email is already registered. Try logging in.",
        "auth/weak-password": "❌ Your password is too weak. Choose a stronger one."
      };
  
      const friendlyMessage = errorMapping[err.code] || "❌ We can't recognize you. Try again.";
      setError(friendlyMessage);
    }
  };
  





  const handleResetPassword = async (e) => {
    e.preventDefault();
    setValidationError("");
    setResetEmailError("");

    if (!validateEmail(resetEmail)) {
      setValidationError("❌ Please enter a valid email address.");
      return;
    }

    try {
      await sendPasswordResetEmail(auth, resetEmail);
      setResetEmailSent(true);
      setResetMode(false);
    } catch (error) {
      setResetEmailError("❌ We can't recognize you.");
    }
  };

  const handleConfirmReset = async (e) => {
    e.preventDefault();
    setValidationError("");

    if (!validatePassword(newPassword)) {
      setValidationError("❌ Password must be at least 8 characters long.");
      return;
    }

    try {
      await confirmPasswordReset(auth, oobCode, newPassword);
      setResetSuccess(true);
    } catch (error) {
      setValidationError("❌ Error resetting password. Please try again.");
    }
  };

  return (
    <Form className="mt-4" style={{ maxWidth: '400px', margin: 'auto' }}>
      {resetEmailSent && (
        <Alert variant="success">An email has been sent to reset your password. Follow the instructions and log in with your new password.</Alert>
      )}
      {oobCode ? (
        resetSuccess ? (
          <>
            <p style={{ fontSize: '16px', color: '#28a745', textAlign: 'center' }}>
              ✅ Password changed successfully!
            </p>
            <Button
              onClick={() => navigate('/welcome')}
              style={{ backgroundColor: '#FF7C24', borderColor: '#FF7C24', width: '100%' }}
            >
              Continue
            </Button>
          </>
        ) : (
          <>
            <Form.Group controlId="formNewPassword" className="mb-3">
              <Form.Label>Enter your new password</Form.Label>
              <Form.Control
                type="password"
                placeholder="Enter new password"
                value={newPassword}
                onChange={(e) => setNewPassword(e.target.value)}
                isInvalid={!validatePassword(newPassword) && newPassword.length > 0}
              />
            </Form.Group>
            {/* {validationError && <p style={{ fontSize: '14px', color: '#FF7C24' }}>{validationError}</p>}
{error && <p style={{ fontSize: '14px', color: '#FF7C24' }}>{error}</p>} */}




            <Button onClick={handleConfirmReset} style={{ backgroundColor: '#FF7C24', borderColor: '#FF7C24', width: '100%' }}>
              Reset Password
            </Button>
          </>
        )
      ) : resetMode ? (
        <>
          <Form.Group controlId="resetEmail" className="mb-3">
            <Form.Label>Enter your email to reset password</Form.Label>
            <Form.Control
              type="email"
              placeholder="Enter your email"
              value={resetEmail}
              onChange={(e) => setResetEmail(e.target.value)}
              isInvalid={!validateEmail(resetEmail) && resetEmail.length > 0}
            />
          </Form.Group>
          {resetEmailError && <p style={{ fontSize: '14px', color: '#FF4C4C' }}>{resetEmailError}</p>}
          <Button onClick={handleResetPassword} style={{ backgroundColor: '#FF7C24', borderColor: '#FF7C24', width: '100%' }}>
            Send Reset Email
          </Button>
        </>
      ) : (
        <>
          <Form.Group controlId="formEmail" className="mb-3">
            <Form.Label style={{ textAlign: 'left', display: 'block' }}>Email address</Form.Label>
            <Form.Control type="email" placeholder="Enter your email" value={email} onChange={(e) => setEmail(e.target.value)} />
          </Form.Group>
          {/* <Form.Group controlId="formPassword" className="mb-3">
            <Form.Label style={{ textAlign: 'left', display: 'block' }}>Password</Form.Label>
            <Form.Control type="password" placeholder="Enter your password" value={password} onChange={(e) => setPassword(e.target.value)} />
          </Form.Group> */}
<Form.Group controlId="formPassword" className="mb-3">
  <Form.Label style={{ textAlign: 'left', display: 'block' }}>Password</Form.Label>
  <Form.Control
    type="password"
    placeholder="Enter your password"
    value={password}
    onChange={(e) => setPassword(e.target.value)}
  />
  <div
    style={{
      fontSize: '13px',
      textAlign: 'left',
      marginTop: '4px',
      color: '#6c757d'
    }}
  >
    🔒 Password must be at least 8 characters long
  </div>
</Form.Group>




          
          {error && <p style={{ fontSize: '14px', color: '#FF7C24' }}>{error}</p>}
          {/* <p className="text-center" style={{ fontSize: 'var(--footnote-size)', color: 'var(--main-orange)' }}>
  {error}
</p> */}

          {successMessage && <p style={{ fontSize: '14px', color: '#28a745' }}>{successMessage}</p>}
          <Button type="submit" onClick={handleAuthWithValidation} style={{ backgroundColor: '#FF7C24', borderColor: '#FF7C24', width: '100%' }}>
            {isSignUp ? 'Sign Up' : 'Login'}

          </Button>
          {!isSignUp && (
            <div className="mt-3 text-center">
              <a href="#" onClick={() => setResetMode(true)} style={{ color: '#FF7C24', fontSize: '14px', textDecoration: 'none' }}>
                Forgot Password?
              </a>
            </div>
          )}
          <div className="mt-3 text-center">
            <a href="#" onClick={toggleAuthMode} style={{ color: '#007BFF', fontSize: '14px', textDecoration: 'none' }}>
              {isSignUp ? 'Already have an account? Login here' : 'Don\'t have an account? Sign up here'}
            </a>
          </div>
          <div className="mt-3 text-center">
            <a href="https://www.fintorro.com/blog/terms-and-conditions" target="_blank" rel="noopener noreferrer">Terms</a> |
            <a href="https://www.fintorro.com/blog/privacy-policy" target="_blank" rel="noopener noreferrer">Privacy Policy</a>
          </div>
        </>
      )}
    </Form>
  );
};

export default AuthForm;






// import React, { useState } from 'react';
// import { Form, Button } from 'react-bootstrap';
// import { useNavigate } from 'react-router-dom';

// const AuthForm = ({
//   isSignUp,
//   email,
//   setEmail,
//   password,
//   setPassword,
//   handleAuth,
//   toggleAuthMode,
//   resetMode,
//   setResetMode,
//   resetEmail,
//   setResetEmail,
//   sendPasswordReset,
//   error,
//   successMessage
// }) => {
//   const navigate = useNavigate();
//   const [validationError, setValidationError] = useState("");

//   const validateEmail = (email) => {
//     const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
//     return emailRegex.test(email);
//   };

//   const validatePassword = (password) => {
//     const passwordRegex = /^(?=.*[A-Z])(?=.*\d)[A-Za-z\d]{8,}$/; // At least 1 uppercase, 1 number, min 8 chars
//     return passwordRegex.test(password);
//   };

//   const handleAuthWithValidation = async (e) => {
//     e.preventDefault();
//     setValidationError("");

//     if (!validateEmail(email)) {
//       setValidationError("❌ Please enter a valid email address.");
//       return;
//     }

//     if (!validatePassword(password)) {
//       setValidationError("❌ Password must be at least 8 characters long, include one uppercase letter and one number.");
//       return;
//     }

//     await handleAuth(e);
//     navigate('/welcome');
//   };

//   return (
//     <Form className="mt-4" onSubmit={handleAuthWithValidation} style={{ maxWidth: '400px', margin: 'auto' }}>
//       {resetMode === false && (
//         <>
//           {/* ✅ Login/Signup Form */}
//           <Form.Group controlId="formEmail" className="mb-3">
//             <Form.Label style={{ fontSize: '16px', color: '#232830', textAlign: 'left', display: 'block' }}>
//               Email address
//             </Form.Label>
//             <Form.Control
//               type="email"
//               placeholder="Enter your email"
//               value={email}
//               onChange={(e) => setEmail(e.target.value)}
//               isInvalid={!validateEmail(email) && email.length > 0}
//               style={{ textAlign: 'left', paddingLeft: '8px' }} // ✅ Left aligned text
//             />
//             <Form.Control.Feedback type="invalid">
//               ❌ Enter a valid email address (e.g., example@domain.com).
//             </Form.Control.Feedback>
//           </Form.Group>

//           <Form.Group controlId="formPassword" className="mb-3">
//             <Form.Label style={{ fontSize: '16px', color: '#232830', textAlign: 'left', display: 'block' }}>
//               Password
//             </Form.Label>
//             <Form.Control
//               type="password"
//               placeholder="Enter your password"
//               value={password}
//               onChange={(e) => setPassword(e.target.value)}
//               isInvalid={!validatePassword(password) && password.length > 0}
//               style={{ textAlign: 'left', paddingLeft: '8px' }} // ✅ Left aligned text
//             />
//             <Form.Control.Feedback type="invalid">
//               ❌ Password must be at least 8 characters, include one uppercase letter and one number.
//             </Form.Control.Feedback>
//           </Form.Group>

//           {/* ✅ Validation & Error Messages */}
//           {validationError && <p style={{ fontSize: '14px', color: '#FF4C4C' }}>{validationError}</p>}
//           {error && <p style={{ fontSize: '14px', color: '#FF7C24' }}>{error}</p>}
//           {successMessage && <p style={{ fontSize: '14px', color: '#28a745' }}>{successMessage}</p>}

//           {/* ✅ Submit Button */}
//           <Button type="submit" style={{ backgroundColor: '#FF7C24', borderColor: '#FF7C24', width: '100%' }}>
//             {isSignUp ? 'Sign Up' : 'Login'}
//           </Button>

//           {/* ✅ Account Toggle Link */}
//           <div className="mt-3 text-center">
//             <span style={{ fontSize: '14px', color: '#232830' }}>Don't have an account? </span>
//             <a href="#" onClick={toggleAuthMode} style={{ color: '#007BFF', fontSize: '14px', fontWeight: 'bold', textDecoration: 'none' }}>
//               Sign up here
//             </a>
//           </div>
//         </>
//       )}

//       {resetMode && (
//         <>
//           {/* ✅ Password Reset Form */}
//           <Form.Group controlId="resetEmail" className="mb-3">
//             <Form.Label style={{ textAlign: 'left', display: 'block' }}>Enter your email to reset password</Form.Label>
//             <Form.Control
//               type="email"
//               placeholder="Enter your email"
//               value={resetEmail}
//               onChange={(e) => setResetEmail(e.target.value)}
//               isInvalid={!validateEmail(resetEmail) && resetEmail.length > 0}
//               style={{ textAlign: 'left', paddingLeft: '8px' }} // ✅ Left aligned text
//             />
//             <Form.Control.Feedback type="invalid">
//               ❌ Enter a valid email address.
//             </Form.Control.Feedback>
//           </Form.Group>

//           {/* ✅ Reset Password Button */}
//           <Button onClick={sendPasswordReset} style={{ backgroundColor: '#FF7C24', borderColor: '#FF7C24', width: '100%' }}>
//             Send Reset Email
//           </Button>
//         </>
//       )}

//       {/* ✅ Terms & Privacy Links */}
//       <div className="mt-3 text-center" style={{ fontSize: '14px', color: '#232830' }}>
//         <a href="https://www.fintorro.com/blog/terms-and-conditions" target="_blank" rel="noopener noreferrer" style={{ color: '#007BFF', textDecoration: 'none' }}>
//           Terms
//         </a>
//         {" | "}
//         <a href="https://www.fintorro.com/blog/privacy-policy" target="_blank" rel="noopener noreferrer" style={{ color: '#007BFF', textDecoration: 'none' }}>
//           Privacy Policy
//         </a>
//       </div>

//       {/* ✅ Help Link */}
//       <div className="mt-3 text-center">
//         <a href="https://wa.me/message/4RKX5CK6X7AZG1" target="_blank" rel="noopener noreferrer" style={{ color: '#007BFF', fontSize: '14px', fontWeight: 'bold', textDecoration: 'none' }}>
//           Need Help?
//         </a>
//       </div>
//     </Form>
//   );
// };

// export default AuthForm;







// import React from 'react';
// import { Form, Button } from 'react-bootstrap';

// const AuthForm = ({
//   isSignUp,
//   email,
//   setEmail,
//   password,
//   setPassword,
//   handleAuth,
//   toggleAuthMode,
//   resetMode,
//   setResetMode,
//   resetEmail,
//   setResetEmail,
//   sendPasswordReset,
//   error,
//   successMessage
// }) => {
//   return (
//     <Form className="mt-4">
//       {resetMode === false && (
//         <>
//           {/* Login/Signup Form */}
//           <Form.Group controlId="formEmail" className="mb-3">
//             <Form.Label style={{ fontSize: '16px', color: '#232830' }}>Email address</Form.Label>
//             <Form.Control
//               type="email"
//               placeholder="Enter your email"
//               value={email}
//               onChange={(e) => setEmail(e.target.value)}
//             />
//           </Form.Group>

//           <Form.Group controlId="formPassword" className="mb-3">
//             <Form.Label style={{ fontSize: '16px', color: '#232830' }}>Password</Form.Label>
//             <Form.Control
//               type="password"
//               placeholder="Enter your password"
//               value={password}
//               onChange={(e) => setPassword(e.target.value)}
//             />
//           </Form.Group>

//           <div className="mt-2">
//             {/* <a href="#" onClick={() => setResetMode(true)} style={{ color: '#FF7C24', fontSize: '14px' }}>
//               Forgot Password?
//             </a> */}
//           </div>

//           {error && <p style={{ fontSize: '14px', color: '#FF7C24' }}>{error}</p>}
//           {successMessage && <p style={{ fontSize: '14px', color: '#28a745' }}>{successMessage}</p>}

//           <Button onClick={handleAuth} style={{ backgroundColor: '#FF7C24', borderColor: '#FF7C24' }}>
//             {isSignUp ? 'Sign Up' : 'Login'}
//           </Button>

//           <div className="mt-3">
//             <a href="#" onClick={toggleAuthMode} style={{ color: '#FF7C24', fontSize: '14px' }}>
//               {isSignUp ? 'Already have an account? Sign in' : "Don't have an account? Sign up"}
//             </a>
//           </div>
//         </>
//       )}

//       {resetMode && (
//         <>
//           {/* Password Reset Form */}
//           <Form.Group controlId="resetEmail" className="mb-3">
//             <Form.Label>Enter your email to reset password</Form.Label>
//             <Form.Control
//               type="email"
//               placeholder="Enter your email"
//               value={resetEmail}
//               onChange={(e) => setResetEmail(e.target.value)}
//             />
//           </Form.Group>

//           {error && <p style={{ fontSize: '14px', color: '#FF7C24' }}>{error}</p>}
//           {successMessage && <p style={{ fontSize: '14px', color: '#28a745' }}>{successMessage}</p>}

//           <Button onClick={sendPasswordReset} style={{ backgroundColor: '#FF7C24', borderColor: '#FF7C24' }}>
//             Send Reset Email
//           </Button>
//         </>
//       )}
//     </Form>
//   );
// };

// export default AuthForm;
